import { Text, Image, Card } from "@chakra-ui/react";

interface ClientCardProps {
  width?: any;
  client: {
    title: string;
    image: string;
    backgroundColor?: string;
  };
}

const ClientCard = ({ width, client }: ClientCardProps): JSX.Element => {
  return (
    <Card variant={"custom"} width={width}>
      <Image
        padding={6}
        borderRadius={"xl"}
        backgroundColor={client.backgroundColor ?? "white"}
        boxSize={"100%"}
        objectFit={"contain"}
        src={client.image}
      />

      <Text fontSize={"1.2rem"} fontWeight={"bold"}>
        {client.title}
      </Text>
    </Card>
  );
};

export default ClientCard;
